import { Component } from '@angular/core';

@Component({
  selector: 'app-pages',
  template: `
    <router-outlet></router-outlet>
  `
})
export class PagesComponent {}
